<template>
  <div class="page-container">
    <LogoLink class="logo-link" />
    <SectionComponent
      class="section-404"
      :section="page404"
      :is-logo-visible="false"
    />
  </div>
</template>

<script>
import SectionComponent from '../components/sections/Section'
export default {
  components: {
    SectionComponent
  },
  data: () => ({
    page404: {
      name: '404',
      slug: '404',
      title: 'Błąd 404',
      subtitle: 'Królewskie nie&nbsp;&nbsp;znalezione',
      linkTitle: 'wróć do strony głównej',
      animation: 'single'
    }
  })
}
</script>

<style lang="scss" scoped>
.section-404 {
  max-width: 100%;
  width: 100%;
  max-height: $vh;
  height: $vh;
  overflow: hidden;
}

.page-container {
  position: relative;
}

.logo-link {
  position: absolute;
  top: 50px;
  left: 15vw;
  z-index: z(logo404);

  @include media-down(xl) {
    left: 18vw;
  }

  @include media-down(lg) {
    top: 40px;
    left: 45px;
  }

  @include media-down(md) {
    top: 20px;
    left: 20px;
  }
}
</style>
